import type {
  OrderRequest,
  OrderPagedResult,
  OrderInvoice,
  ConfiguredOrderRequest,
  QueryParams,
} from '~/types/api'
export function createOrdersRepository() {
  const { $api } = useNuxtApp()
  const { get, post } = baseRepository($api)

  const DOMAIN = 'orders'
  const DOMAIN_CONFIGURED = 'configured'
  const DOMAIN_HASH = 'hash'
  const DOWNLOAD = 'download'

  async function create(body: OrderRequest) {
    return post<unknown>([DOMAIN], { body })
  }

  async function createConfigured(body: ConfiguredOrderRequest) {
    return post<unknown>([DOMAIN, DOMAIN_CONFIGURED], { body })
  }

  async function getPage(params?: QueryParams) {
    return get<OrderPagedResult>([DOMAIN], { params })
  }

  async function getAll() {
    return getAllPages<OrderPagedResult, undefined>(getPage, undefined)
  }

  async function getByHash(
    hash: string,
    params: {
      configurationNid?: number
      customerGroupNid?: number
      priceCategoryNid?: number
      token?: string
    }
  ) {
    return get<OrderInvoice>([DOMAIN, DOMAIN_HASH, hash], {
      params,
    })
  }

  async function getFileByHash(
    hash: string,
    params: {
      customerGroupNid?: number
      priceCategoryNid?: number
    }
  ) {
    return get<Blob>([DOMAIN, DOMAIN_HASH, hash, DOWNLOAD], {
      params,
    })
  }

  return {
    create,
    createConfigured,
    getByHash,
    getFileByHash,
    getPage,
    getAll,
  }
}
